<template>
  <div class="page">
    <el-container style="height: 100vh;">
      <el-header style="height: 120px">
        <div class="header">
          <img class="logo" src="@/assets/imgs/logo.png" />
          <div class="menu-content">
            <el-menu
              :default-active="activeMenu"
              class="el-menu-demo"
              mode="horizontal"
              background-color="#010001"
              menu-trigger="hover"
              :unique-opened="true"
              @select="handleSelect"
            >
              <template v-for="item in menuList" >
                <el-menu-item v-if="!item.children" class="menu-item menu-item-first" :key="item.key" :index="item.name" @click="resetOtherParents(item)">
                  {{ item[currentLanguage] }}
                </el-menu-item>
                <el-submenu :popper-append-to-body="false" class="menu-item" popper-class="sub-mennu-content" :key="item.key" :index="item.name" v-else >
                  <template slot="title">
                    <div class="title-text">{{ item[currentLanguage] }}</div>
                  </template>
                  <el-menu-item
                    v-for="child in item.children"
                    :key="child.key"
                    :index="child.name"
                    @click="updateParentMenu(item, child)"
                  >
                    {{ child[currentLanguage] }}
                  </el-menu-item>
                </el-submenu>
              </template>
            </el-menu>
          </div>
          <div class="language-content">
            <el-dropdown @command="handleChangeLanguage">
              <span class="el-dropdown-link">
                <img class="ball" src="@/assets/imgs/ball.png" />
                {{ currentLanguage }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="item in languageList" :class="[item == currentLanguage ? 'active' : '']" :key="item" :command="item">
                  {{ item }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </el-header>
      <el-main>
        <div v-if="activeMenu !== 'home'" class="main-body">
          <div class="box">
            <div class="maindiv">
              <div class="tab-body">
                <div class="tab-content" ref="tab-content-ref">
                  <div
                    v-for="(item, index) in currentTabList"
                    :key="index"
                    :ref="`tab-item${index}`"
                    :class="['tab-item', index == currentTabActive ? 'active' : '']"
                    @click="handleChangeTab(index)"
                  >
                    {{ item[currentLanguage] }}
                  </div>
                </div>
                <div class="box-shadow left"></div>
                <div class="box-shadow right"></div>
              </div>
              
              <div class="container">
                <div class="page-body">
                  <div class="carousel-body">
                    <el-carousel ref="carousel" class="carousel" :initial-index="0" :loop="false" :autoplay="false" indicator-position="none" :interval="2000" arrow="never" >
                      <el-carousel-item v-for="item in imageArray" :key="item" :name="item">
                        <div class="image" :style="{ backgroundImage: `url(${item})` }"></div>
                      </el-carousel-item>
                    </el-carousel>
                  </div>
                  <div :class="['swiper-arrow swiper-arrow-left', isLeftDiabled ? 'disbled' : '']" @click="handleChangeSwiper('left')"></div>
                  <div :class="['swiper-arrow swiper-arrow-right', isRightDiabled ? 'disbled' : '']" @click="handleChangeSwiper('right')"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="page-content-sy">
          <div class="images" v-for="(item, index) in imageArray" :key="index" :style="{ backgroundImage: `url(${item})` }"></div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { allMenuList, tabListMap } from './index.js'

export default {
  name: 'HomePage',
  data() {
    return {
      currentLanguage: 'cn',
      languageList: ['cn', 'en'],
      activeMenu: '',
      currentTabActive: 0,
      currentTabList: [],
      imageArray: [],
      menuList: [],
    }
  },
  watch: {
    activeMenu: {
      handler() {
        this.getImageArray();
      },
      immediate: true
    },
  },
  computed: {
    isLeftDiabled() {
      return this.currentTabActive === 0;
    },
    isRightDiabled() {
      return this.currentTabActive === this.currentTabList.length - 1;
    },
  },
  created() {
    this.menuList = JSON.parse(JSON.stringify(allMenuList));
    
    const savedLanguage = sessionStorage.getItem('language');
    this.currentLanguage = savedLanguage || 'cn';
    
    // this.activeMenu = allMenuList[0].name || '';
    this.activeMenu ='qita' || '';
    window.addEventListener('resize', this.setViewportHeight);
  },
  methods: {
    setViewportHeight() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },
    // 点击切换菜单
    handleSelect(key, keyPath ) {
      if (keyPath.length > 1) {
        this.activeMenu = keyPath[1];
      } else {
        this.activeMenu = keyPath[0];
      }
    },

    // 点击子元素
    updateParentMenu(item, child) {
      // 恢复其他父菜单文案
      this.resetOtherParents(item);
      // 更新当前父菜单文案
      item[this.currentLanguage] = child[this.currentLanguage];
      this.activeMenu = child.name;
    },
    // 点击父菜单
    resetOtherParents(currentItem) {
      this.menuList.forEach(item => {
        if (item.name !== currentItem.name) {
          const originalItem = allMenuList.find(i => i.name === item.name);
          if (originalItem) {
            item[this.currentLanguage] = originalItem[this.currentLanguage];
          }
        }
      });
      setTimeout(() => {
        if (this.activeMenu == 'home') return
        let scrollContainer = this.$refs['tab-content-ref'];
        scrollContainer.scrollTo({
          left: 0,
          behavior: 'smooth',
        })
      }, 16.7)
    },
    handleChangeTab(index) {
      this.currentTabActive = index;
      this.$refs.carousel && this.$refs.carousel.setActiveItem(index);
      this.scrollToTab(index);
    },
    scrollToTab(val, isLimit) {
      setTimeout(() => {
        let scrollContainer = this.$refs['tab-content-ref'];
        let tabIndex = val;
        if (isLimit) {
          tabIndex++;
        }
        let totalOffset = 0;
        for (let index = 0; index < tabIndex; index++) {
          totalOffset = this.$refs[`tab-item${index}`][0].offsetWidth + totalOffset + 3
        }
        if (tabIndex !== -1) {
          scrollContainer.scrollTo({
            left: totalOffset,
            behavior: 'smooth',
          })
        }
      }, 20)
    },
    handleChangeSwiper(direction) {
      if (direction == 'right') {
        if (this.isRightDiabled) return;
        this.currentTabActive++;
        this.$refs.carousel.next();
        this.scrollToTab(this.currentTabActive, this.isRightDiabled)
      } else {
        if (this.isLeftDiabled) return;
        this.currentTabActive--;
        this.$refs.carousel.prev();
        this.scrollToTab(this.currentTabActive)
      }
    },
    // 点击切换语言
    handleChangeLanguage(lang) {
      if (lang === this.currentLanguage) return
      this.activeMenu = 'home'
      this.currentTabActive = 0
      this.currentLanguage = lang;
      this.getImageArray();
      sessionStorage.setItem('language', lang);
    },
    getImageArray() {
      const list = tabListMap[this.activeMenu];
      this.currentTabActive = 0;
      if (list) {
        this.currentTabList = list;
        const currentTabImageListLen = list.length;
        const imageArray = Array.from({ length: currentTabImageListLen }, (_, index) => require(`@/assets/imgs/pc/${this.activeMenu}/${this.currentLanguage}_${index + 1}.png`));

        this.imageArray = imageArray || [];
      } else {
        this.currentTabList = [];
        this.imageArray = [];
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setViewportHeight); // 移除事件监听
  }
}
</script>

<style scoped lang="scss">
.page {
  background: #EDF0F9;
  height: 100%;
  .el-header {
    padding: 0 60px;
    background: #010001;
  }
  .el-main {
    padding: 0;
    overflow-y: hidden;
    display: flex;
  }
}
.header {
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: space-between;
  align-content: center;

  .logo {
    width: 273px;
    height: 120px;
    padding-right: 30px;
    object-fit: contain;
  }

  .menu-content {
    flex: 1;
    display: flex;
    justify-content: end;
    align-items: center;
    .el-menu-demo {
      display: flex;
      flex-wrap: wrap;
    }

    .menu-item {
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #BABABA;
      height: 40px;
      line-height: 40px;
      
      &.is-active {
        font-size: 18px;
        color: #fff;
        border-bottom: 2px solid transparent;
        position: relative;
        max-width: 140px;

        &::after {
          position: absolute;
          content: '';
          left: 15px;
          bottom: 0;
          width: calc(100% - 30px);
          height: 4px;
          background: #4FA0FF;
          border-radius: 10px;
        }

        ::v-deep .el-submenu__title {
          color: #FFFFFF;
          border-bottom: 4px solid transparent;
          .title-text {
            max-width: 110px;
          }
          .el-submenu__icon-arrow {
            position: absolute;
            right: 0;
            color: #fff;
            margin-top: -4px;
          }
        }

        &.menu-item-first {
          max-width: 140px;
        }
      }

      &.el-menu-item {
        padding: 0 15px;
      }
      ::v-deep .el-submenu__title {
        padding: 0 15px;
      }
      ::v-deep .el-submenu__title {
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #BABABA;
        border-bottom: 4px solid transparent;
        height: 40px;
        line-height: 40px;
        display: flex;
        align-items: center;
        .title-text {
          max-width: 110px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .el-submenu__icon-arrow {
          color: #BABABA;
          margin-top: 2px;
        }
        &:hover {
          color: #fff;
          .el-submenu__icon-arrow {
            color: #fff;
          }
        }
      }
    }

    .menu-item-first {
      max-width: 140px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
      color: #fff;
    }

    .el-menu.el-menu--horizontal {
      border-color: transparent;
    }
  }

  .language-content {
    width: 70px;
    display: flex;
    align-items: center;
    margin-left: 15px;
    cursor: pointer;
    .el-dropdown-link {
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 18px;
      line-height: 25px;
      letter-spacing: 0%;
      text-transform: uppercase;
      color: #BABABA;
      display: flex;
      align-items: center;

      .ball {
        width: 18px;
        height: 18px;
        margin-right: 5px;
      }
      .el-icon--right {
        font-size: 12px;
        margin-left: 5px;
      }
    }
  }
}

.main-body {
  box-sizing: border-box;
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 650px;
  overflow: hidden;
  overflow-y: auto;
  padding-top: 30px;
  .box {
    .maindiv {
      box-sizing: border-box;
      display: flex;
      flex: 1;
      flex-direction: column;
      height: calc(var(--vh, 1vh)* 82);
      // min-height: 700px;
      min-width: 650px;
      overflow: hidden;
      overflow-y: auto;
      width: 100%;

      .container {
        align-items: center;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: auto 100%;
        box-sizing: border-box;
        display: flex;
        flex: 1;
        flex-direction: column;
        min-height: 200px;

        .page-body {
          box-sizing: border-box;
          flex: 1;
          overflow: hidden;
          position: relative;
          // width: calc(9.13px * 100 / 1164 * 1600 - 158.0756px);
          width: calc(var(--vh, 1vh)* 100 / 1264* 1900 - 120px);
          position: relative;
          padding: 0 60px;

          .carousel-body {
            width: 100%;
            height: 100%;

            .carousel {
              background-position: 50%;
              background-repeat: no-repeat;
              background-size: auto 100%;
              height: 100%;
              margin: 0 auto;
              width: 100%;
              position: relative;

              ::v-deep .el-carousel__container {
                height: 100%;
                margin-left: auto;
                margin-right: auto;
                overflow: hidden;
                padding: 0;
                position: relative;
                width: 100%;
              }

              :v-deep .el-carousel__item {
                background-position: 50%;
                background-size: cover;
                min-height: 100%;
                display: flex;
                flex-direction: column;
                flex-wrap: nowrap;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 100%;
                overflow: hidden;
              }

              .image {
                background-position: center;
                background-repeat: no-repeat;
                background-size: 98% 93%;
                box-sizing: border-box;
                height: 100%;
                width: 100%;
              }
            }
          }

          .swiper-arrow {
            position: absolute;
            width: 60px;
            height: 60px;
            top: calc(50% - 30px);
            cursor: pointer;
            z-index: 2;
            background: no-repeat center center/98% 98% url('@/assets/imgs/arrow.png');
          }
          .swiper-arrow-left {
            left: 0;
            transform: rotate(180deg);
          }
          .swiper-arrow-right {
            right: 0;
          }
          .disbled {
            opacity: 0.4;
          }
        }
      }
    }
  }
}

.page-content-sy {
  width: 100%;
  height: 100%;

  .images {
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    box-sizing: border-box;
    height: 100%;
    width: 100%;
  }

}
.tab-body {
  width: calc(var(--vh, 1vh)* 100 / 1264* 1900 - 120px);
  margin: auto;
  position: relative;
  .box-shadow {
    position: absolute;
    width: 70px;
    height: 50px;
    top: 0;
  }
  .left {
    left: 0;
    background: linear-gradient(270deg, rgba(237, 240, 249, 0) 0%, #EDF0F9 100%);

  }
  .right {
    right: 0;
    background: linear-gradient(270deg, #EDF0F9 0%, rgba(237, 240, 249, 0) 100%);
  }
}

.tab-content {
  overflow-x: auto;
  display: flex;
  &::-webkit-scrollbar {
    display: none
    // height: 60px; /* 滚动条高度 */
    // position: absolute;
    // top: -10px;
    // left: 0;
  }
  
  /* 对于滚动条滑块 */
  &::-webkit-scrollbar-thumb {
    background: transparent;  /* 滑块颜色 */
    position: absolute;
    scrollbar-width: none;
  }
  
  /* 对于滚动条轨道 */
  &::-webkit-scrollbar-track {
    background: transparent;  /* 轨道颜色 */
  }

  .tab-item {
    flex-shrink: 0;
    line-height: 50px;
    background: #C5C5C5;
    padding: 0 25px;
    font-family: 'PingFang SC';
    font-weight: 500;
    font-size: 22px;
    margin-right: 50px;
    color: #fff;
    position: relative;
    margin-left: 20px;
    cursor: pointer;

    &::before {
      position: absolute;
      content: '';
      left: -20px;
      top: 0px;
      width: 20px;
      height: 50px;
      background: no-repeat center center/100% 100% url('@/assets/imgs/left.png');
    }
    &::after {
      position: absolute;
      content: '';
      right: -19px;
      top: 0;
      width: 20px;
      height: 50px;
      background: no-repeat center center/100% 100% url('@/assets/imgs/right.png');
    }
  }

  .active {
    background: #4FA0FF;
    &::before {
      background: no-repeat center center/100% 100% url('@/assets/imgs/select-left.png');
    }
    &::after {
      background: no-repeat center center/100% 100% url('@/assets/imgs/select-right.png');
    }
  }
}

::v-deep .sub-mennu-content {
  margin: 0 auto;
  .el-menu--popup {
    border-radius: 14px;
    min-width: auto;
    padding: 16px 0 0;

    .el-menu-item {
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #BABABA;
      background: transparent !important;
      padding: 0 30px;
      margin-bottom: 16px;

      &.is-active {
        color: #fff;
      }
    }
  }
}

::v-deep .el-submenu .el-menu-item {
  margin: 0 auto;
  min-width: auto;
}

.el-popper {
  background: #010001;
  border-color: #010001;
  .el-dropdown-menu__item {
    font-size: 18px;
    text-transform: uppercase;
    color: #BABABA;

    &.active {
      color: #fff;
    }
  }
  .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
    background: transparent;
  }
  ::v-deep .popper__arrow {
    opacity: 0;
    display: none;
    border-bottom-color: #010001;
  }
}
</style>